// import ParentWrapper from "../../../components/ParentWrapper";
// import { useState, useEffect } from "react";
// import {
//   Box,
//   Button,
//   Typography,
//   Alert,
//   CircularProgress,
// } from "@mui/material";
// import CloudUploadIcon from "@mui/icons-material/CloudUpload";
// import { theme as colorTheme } from "../../../Convoze.theme";
// import { useFormik } from "formik";
// import * as Yup from "yup";
// import apiEndPointsConfig from "../../../services/apiEndPoints";
// import axios from "axios";

// const primary = colorTheme("palette", "primary").value;

// const validationSchema = Yup.object({
//   file: Yup.mixed()
//     .required("A file is required")
//     .test("singleFile", "Only one file is allowed", (v) => v instanceof File),
// });

// export default function Training() {
//   const [success, setSuccess] = useState(false);
//   const [timeLeft, setTimeLeft] = useState(0);
//   const [uploading, setUploading] = useState(false);
 
//   useEffect(() => {
//     let timer;
//     if (timeLeft > 0)
//       timer = setInterval(() => setTimeLeft((t) => t - 1), 1000);
//     return () => clearInterval(timer);
//   }, [timeLeft]);

//   const formatTime = (s) => {
//     const h = String(Math.floor(s / 3600)).padStart(2, "0");
//     const m = String(Math.floor((s % 3600) / 60)).padStart(2, "0");
//     const sec = String(s % 60).padStart(2, "0");
//     return `${h} : ${m} : ${sec}`;
//   };

//   const formik = useFormik({
//     initialValues: { file: null },
//     validationSchema,
//     onSubmit: async ({ file }) => {
//       setUploading(true);
//       const formdata = new FormData();
//       formdata.append("files", file);
//       try {
//         const token = localStorage.getItem("token");
//         if (!token) return;
//         const res = await axios.post(
//           `${apiEndPointsConfig?.uploadSop}`,
//           formdata,
//           { headers: { Authorization: `Bearer ${token}` } }
//         );
//         if (res.status === 200) {
//           setUploading(false);
//           setSuccess(true);
//           setTimeLeft(72 * 60 * 60);
//           formik.resetForm();
//         } else {
//           setUploading(false);
//           alert("Upload failed. Try again.");
//           console.error(res);
//         }
//       } catch (error) {
//         setUploading(false);
//         alert("Something went wrong.");
//         console.error(error);
//       }
//     },
//   });

//   return (
//     <ParentWrapper>
//       <Box sx={{ p: 3, boxShadow: 3, borderRadius: 6 }}>
//         <Typography variant="h5" gutterBottom>
//           Training Activation Form
//         </Typography>

//         <form onSubmit={formik.handleSubmit}>
//           <Button
//             variant="outlined"
//             component="label"
//             fullWidth
//             startIcon={<CloudUploadIcon />}
//             sx={{
//               color: primary,
//               borderRadius: 2,
//               mt: 2,
//               border: "none",
//               "&:focus-within": { border: `2px solid ${primary}` },
//             }}
//           >
//             Upload QA SOP (PDF/DOC/TXT)
//             <input
//               required
//               type="file"
//               hidden
//               accept=".pdf,.doc,.docx,.txt"
//               onChange={(e) =>
//                 formik.setFieldValue("file", e.target.files?.[0])
//               }
//             />
//           </Button>

//           {formik.touched.file && formik.errors.file && (
//             <Typography variant="caption" color="error" sx={{ ml: 2 }}>
//               {formik.errors.file}
//             </Typography>
//           )}

//           {formik.values.file && (
//             <Typography variant="body2" sx={{ mt: 1, textAlign: "center" }}>
//               Selected File: {formik.values.file.name}
//             </Typography>
//           )}

//           {!success && (
//             <Button
//               type="submit"
//               variant="contained"
//               fullWidth
//               disabled={uploading}
//               sx={{
//                 borderRadius: 2,
//                 mt: 3,
//                 backgroundColor: primary,
//                 border: "none",
//                 "&:focus": { border: `2px solid ${primary}` },
//               }}
//             >
//               {uploading ? (
//                 <CircularProgress size={24} color="inherit" />
//               ) : (
//                 "Submit"
//               )}
//             </Button>
//           )}

//         </form>

//         {success && (
//           <Alert severity="success" sx={{ mt: 3 }}>
//             Training Activated! Time left: {formatTime(timeLeft)}
//           </Alert>
//         )}
//       </Box>
//     </ParentWrapper>
//   );
// }




import ParentWrapper from "../../../components/ParentWrapper";
import { useState, useEffect } from "react";
import {
  Box,
  Button,
  Typography,
  CircularProgress,
  Alert,
} from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { theme as colorTheme } from "../../../Convoze.theme";
import { useFormik } from "formik";
import * as Yup from "yup";
import apiEndPointsConfig from "../../../services/apiEndPoints";
import axios from "axios";

const primary = colorTheme("palette", "primary").value;

const validationSchema = Yup.object({
  file: Yup.mixed()
    .required("A file is required")
    .test("singleFile", "Only one file is allowed", (v) => v instanceof File),
});

export default function Training() {
  /* -------------- state -------------- */
  const [status, setStatus]   = useState("idle"); // idle | uploading | success | error
  const [timeLeft, setTimeLeft] = useState(0);

  /* -------------- countdown -------------- */
  useEffect(() => {
    if (!timeLeft) return;
    const id = setInterval(() => setTimeLeft((t) => t - 1), 1000);
    return () => clearInterval(id);
  }, [timeLeft]);

  /* -------------- helpers -------------- */
  const formatTime = (s) => {
    const h = String(Math.floor(s / 3600)).padStart(2, "0");
    const m = String(Math.floor((s % 3600) / 60)).padStart(2, "0");
    const sec = String(s % 60).padStart(2, "0");
    return `${h}:${m}:${sec}`;
  };

  /* -------------- form -------------- */
  const formik = useFormik({
    initialValues : { file: null },
    validationSchema,
    onSubmit      : async ({ file }) => {
      setStatus("uploading");
      const fd = new FormData();
      fd.append("files", file);

      try {
        const token = localStorage.getItem("token");
        if (!token) throw new Error("No token");

        const res = await axios.post(
          `${apiEndPointsConfig?.uploadSop}`,
          fd,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        if (res.status === 200) {
          setStatus("success");
          setTimeLeft(72 * 60 * 60);
          formik.resetForm();
        } else {
          throw new Error("Upload failed");
        }
      } catch (e) {
        setStatus("error");
        console.error(e);
      }
    },
  });

  /* -------------- banner text -------------- */
  const bannerMessage = {
    idle    : null,
    uploading: null,
    success : "Training activated successfully!",
    error   : "Upload failed. Please try again.",
  }[status];

  /* -------------- UI -------------- */
  return (
    <ParentWrapper>
      <Box sx={{ p: 3, boxShadow: 3, borderRadius: 6, backgroundColor: "#fff" }}>
        <Typography variant="h5" gutterBottom>
          Training Activation Form
        </Typography>

        {/* ---------- in-content banner ---------- */}
        {bannerMessage && (
          <Alert severity={status === "success" ? "success" : "error"} sx={{ mb: 2 }}>
            {bannerMessage}
          </Alert>
        )}

        <form onSubmit={formik.handleSubmit}>
          {/* ---------- upload button ---------- */}
          <Button
            variant="outlined"
            component="label"
            fullWidth
            startIcon={<CloudUploadIcon />}
            sx={{
              color: primary,
              borderRadius: 2,
              mt: 2,
              border: "none",
              "&:focus-within": { border: `2px solid ${primary}` },
            }}
          >
            Upload QA SOP (PDF/DOC/TXT)
            <input
              hidden
              type="file"
              accept=".pdf,.doc,.docx,.txt"
              onChange={(e) =>
                formik.setFieldValue("file", e.target.files?.[0] || null)
              }
            />
          </Button>

          {formik.touched.file && formik.errors.file && (
            <Typography variant="caption" color="error" sx={{ ml: 2 }}>
              {formik.errors.file}
            </Typography>
          )}

          {formik.values.file && (
            <Typography variant="body2" sx={{ mt: 1, textAlign: "center" }}>
              Selected File: {formik.values.file.name}
            </Typography>
          )}

          {/* ---------- submit / timer button ---------- */}
          <Button
            type="submit"
            variant="contained"
            fullWidth
            disabled={status === "uploading" || status === "success"}
            sx={{
              borderRadius: 2,
              mt: 3,
              backgroundColor: primary,
              border: "none",
              "&:focus": { border: `2px solid ${primary}` },
            }}
          >
            {status === "uploading" ? (
              <CircularProgress size={24} backgroundColor={primary}  />
            ) : status === "success" ? (
              `Uploaded successfully `
            ) : (
              "Submit"
            )}
          </Button>
        </form>
      </Box>
    </ParentWrapper>
  );
}